import type { Capability } from '@taler/api-client'

/** The one place this feature's view gate is written; the nav and the route both call it. */
export function canManageMembership(can: (capability: Capability) => boolean): boolean {
  return can('MEMBERSHIP_MANAGE')
}
